import { render, staticRenderFns } from "./412258e5-24ea-418c-ab0b-eda9b508f8f8.vue?vue&type=template&id=0fc8b484&scoped=true"
import script from "./412258e5-24ea-418c-ab0b-eda9b508f8f8.vue?vue&type=script&lang=ts"
export * from "./412258e5-24ea-418c-ab0b-eda9b508f8f8.vue?vue&type=script&lang=ts"
import style0 from "./412258e5-24ea-418c-ab0b-eda9b508f8f8.vue?vue&type=style&index=0&id=0fc8b484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc8b484",
  null
  
)

export default component.exports